import React from 'react';

import { usePermissions } from '../../hooks/usePermissions';

const PermissionGate = ({ permission, anyOf, mode = 'hide', children }) => {
  const { can, canAny } = usePermissions();

  const hasAnyOf = Array.isArray(anyOf) && anyOf.length > 0;
  const allowed = hasAnyOf ? canAny(anyOf) : Boolean(permission) && can(permission);

  if (allowed) return children;

  if (mode === 'disable' && React.isValidElement(children)) {
    return React.cloneElement(children, { disabled: true });
  }

  return null;
};

export default PermissionGate;
